import { AppBar, useTheme } from "@mui/material";
import React, { ReactNode } from "react";

import Grid from "@mui/material/Grid";
import { ITest } from "@websential/cosmic-v20";

export interface ITwoColumnLayout extends ITest {
	toolbar: ReactNode;
	leftColumnContent: ReactNode;
	rightColumnContent: ReactNode;
	toolbarPosition?: string;
	showToolbar?: boolean;
	showBorder?: boolean;
}

export const TwoColumnLayout: React.FC<ITwoColumnLayout> = ({
	toolbar,
	leftColumnContent,
	rightColumnContent,
	testId,
	toolbarPosition = "top",
	showToolbar = true,
	showBorder = true,
}) => {
	const theme = useTheme();
	return (
		<Grid
			container
		// columnSpacing={{ xs: 0, sm: 2, md: 3, lg: 3, xl: 3 }}
		// sx={{ marginTop: theme.spacing(2) }}
		>
			<Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
				{toolbarPosition === "top" ? (
					<div>
						{showToolbar && (
							// <AppBar
							// 	position="sticky"
							// 	color="default"
							// 	elevation={1}
							// 	data-testId={testId}
							// 	sx={{
							// 		backgroundColor: "#fff",
							// 		borderRadius: "5px",
							// 		marginBottom: theme.spacing(4),
							// 		top: theme.mixins.toolbar.minHeight,
							// 	}}
							// >
							<>{toolbar}</>
							// </AppBar>
						)}
						<Grid
							container
							columnSpacing={{ xs: 0, sm: 6, md: 7, lg: 16, xl: 16 }}
							sx={{
								border: showBorder ? "1px solid rgba(0, 0, 0, 0.12)" : 0,
								background: "#ffffff",
							}}
						>
							<Grid size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
								{leftColumnContent}
							</Grid>
							{/* <Grid size={{ xs: 0, sm: 0, md: 0.5, lg: 1.5, xl: 1.5 }}></Grid> */}
							<Grid size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
								{rightColumnContent}
							</Grid>
						</Grid>
					</div>
				) : (
					<div>
						<Grid
							container
							columnSpacing={{ xs: 0, sm: 6, md: 7, lg: 16, xl: 16 }}
							sx={{
								border: showBorder ? "1px solid rgba(0, 0, 0, 0.12)" : 0,
								background: "#ffffff",
							}}
						>
							<Grid size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
								{leftColumnContent}
							</Grid>
							{/* <Grid size={{ xs: 0, sm: 0, md: 0.5, lg: 1.5, xl: 1.5 }}></Grid> */}
							<Grid size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
								{rightColumnContent}
							</Grid>
						</Grid>
						{showToolbar && (
							<AppBar
								position="sticky"
								color="default"
								elevation={1}
								data-testId={testId}
								sx={{
									backgroundColor: "#fff",
									// marginTop: theme.spacing(3),
									boxShadow: "none",
									alignItems: "center",
									zIndex: 0,
									position: "sticky",
									bottom: 0,
								}}
							>
								{toolbar}
							</AppBar>
						)}
					</div>
				)}
			</Grid>
		</Grid>
	);
};
